export class CSVRecord {
    public First_name: any;  
	public Last_name: any;  
	public Company_name : any;  
    public Mobile_number: any;    
    public Tag_name:any;
    public Tag_name1:any;

}
